import { useEffect } from 'react';

import COOKIES from '~/constants/cookies';
import { Events } from '~/constants/events';
import Pinchpoints from '~/constants/pinchpoints';
import { identifyUser, trackEvent } from '~/helpers/analytics';
import { useCookie, expireCookie } from '~/helpers/cookies';
import { useLoggedInUser } from '~/hooks/useLoggedInUser';

/**
 * Set the referral utm values on the analytics user and expire cookies
 * @returns void
 */
export const useReferralUtmValues = ({ pinchpoint }: { pinchpoint: Pinchpoints }) => {
  const [referralUtmMedium] = useCookie(COOKIES.REFERRAL_UTM_MEDIUM);
  const [referralUtmSource] = useCookie(COOKIES.REFERRAL_UTM_SOURCE);
  const { loggedInUser } = useLoggedInUser();

  useEffect(() => {
    if (loggedInUser && referralUtmMedium && referralUtmSource) {
      identifyUser(loggedInUser.id, {
        utm_medium: referralUtmMedium,
        utm_source: referralUtmSource,
      });
      trackEvent({
        name: Events.SiteVisitedWithReferralRedeemCode,
        properties: {
          pinchpointLocation: pinchpoint,
        },
      });
      expireCookie({ name: COOKIES.REFERRAL_UTM_MEDIUM });
      expireCookie({ name: COOKIES.REFERRAL_UTM_SOURCE });
    }
  }, [referralUtmMedium, referralUtmSource, loggedInUser]);

  return null;
};
